import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { MappingService } from "../../../../core/services/mapping.service";
import { MapDataComponent } from "../modals/map-data/map-data.component";
import { EditMapDataComponent } from "../modals/edit-data/edit-data.component";
import { ViewMapDataComponent } from "../modals/view-data/view-data.component";

@Component({
  selector: "app-security",
  // imports: [],
  templateUrl: "./security.component.html",
  styleUrl: "./security.component.css",
  standalone: false,
})
export class SecurityComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"] && changes["isActive"].currentValue === true) {
      // your logic to fetch unprocessed issuer data
      console.log("Issuer is active — load data now");
    }
  }
}
